import React from 'react';
import { Col } from 'react-bootstrap';
import PageHeader, { PageHeaderRow } from '../../../components/PageHeader';
import SchedulerShiftsNav from '../SchedulerShiftsNav';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { useFlairBreadcrumbHook } from '../../../../../hooks/useFlairBreadcrumbHook';

const i18Path = 'navigation.menuItems.time';

const SchedulerShiftsHeader: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const t = useNamespacedTranslation(i18Path);
  const title = t('subMenuItems.schedulerShifts.title');

  useFlairBreadcrumbHook([{ label: t('title') }, { label: title }]);

  return (
    <PageHeader title={title}>
      <PageHeaderRow>
        <Col>
          <SchedulerShiftsNav />
        </Col>
      </PageHeaderRow>
    </PageHeader>
  );
};

export default SchedulerShiftsHeader;
